<template>
  <div :class="{ 'bto-sb-widget-content': outrightSports.length === 0 }">
    <empty-state
      v-if="outrightSports.length === 0"
      :message="emptyStateStatusMessage"
      :icon-class="emptyStateClass" />
    <!-- eslint-disable -->
    <div
      class="bto-sb-widget bto-sb-widget-category bto-sb-category-outrights bto-sb-sports-icon"
      v-for="(sport, idx) in outrightSports"
      :class="getSportClass(sport.id)"
      :key="idx"
      v-if="outrightsType === 'tournament'">
      <div class="bto-sb-widget-title">
        <h3>{{ sport.name }}</h3>
      </div>
      <outrights-tab-component
        v-if="
          sport.tabs.find(
            (t) =>
              t.id == routeId ||
              `tg${t.id}` == routeId ||
              (t.id === 0 && `c${t.categoryId}` == routeId)
          )
        "
        v-for="(routeId, idx) in fixtureIds.slice().reverse()"
        :category="
          sport.tabs.find(
            (t) =>
              t.id == routeId ||
              `tg${t.id}` == routeId ||
              (t.id === 0 && `c${t.categoryId}` == routeId)
          )
        "
        :key="idx"
        :isCategoryList="false" />
    </div>

    <div
      class="bto-sb-widget bto-sb-widget-category bto-sb-category-outrights bto-sb-sports-icon"
      v-for="(sport, idx) in outrightSports"
      :class="getSportClass(sport.id)"
      :key="idx"
      v-if="outrightsType === 'category'">
      <div class="bto-sb-widget-title">
        <h3>{{ sport.name }}</h3>
      </div>
      <category-outrights-nav-component 
       :tabs="sport.tabs"
       v-model="activeSportTournaments[idx]"
       v-if="sport.tabs.length > 1"
      /> 
      <outrights-tab-component
        :category="sport.tabs.find( t => t.id === activeSportTournaments[idx])"
        :isCategoryList="false" />
    </div>
  </div>
</template>

<script>
  import store from '../../../store';
  import { CategoryOutrightsRequestService } from './service-category-outrights';
  import { TournamentOutrightsRequestService } from './service-tournament-outrights';
  import DateFilterService from '../../../services/date-filter-service';
  import { EventBus } from '../../../services/event-bus-service';
  import FullSportModel from '../../../models/full-sport-model';
  import OutrightsTabComponent from './component-outrights-tab';
  import CategoryOutrightsNavComponent from './component-category-outrights-nav';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';

  export default {
    name: 'CategoryOutrightsWidget',
    components: {
      OutrightsTabComponent,
      CategoryOutrightsNavComponent,
      EmptyState,
    },
    data() {
      return {
        outrightSports: [], // sports -> categories/tabs -> outrights -> outcomes
        prevTournamentIds: [],
        tournamentIds: [],
        prevCategoryIds: [],
        categoryIds: [],
        prevOutrightsType: undefined,
        emptyStateIcon: ICON_CLASS.OUTRIGHTS,
        loading: false,
        loadingSpinner: ICON_CLASS.LOADING,
        activeTournament: 0,
        widgetCategoryOutrights: 0,
        activeSportTournaments: [],
      };
    },
    props: {
      fixtureIds: {
        type: Array,
        required: false,
        default: () => [],
      },
      outrightsType: {
        type: String,
      },
    },
    created() {
      this.initOutrights();
    },
    watch: {
      fixtureIds() {
        this.initOutrights();
      },
    },
    updated() {
      if (this.outrightsType === 'category') {
        try {
          EventBus.$emit('updateTabCategoryName', this.outrightSports[0].tabs[0].categoryName, this.outrightSports[0].class);
        } catch (error) {
          // eslint-disable-next-line
          console.warn('could not retrieve category name for outrights');
        }
      }
    },
    computed: {
      emptyStateClass() {
        return this.loading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.loading ? this.t('Mobile.LoadingMore') : this.t('W.NoOutrights');
      },
    },
    methods: {
      initOutrights() {
        this.loading = true;
        if (!this.prevOutrightsType) {
          this.prevOutrightsType = this.outrightsType;
        } else if (this.outrightsType !== this.prevOutrightsType) {
          this.outrightSports = [];
          this.prevTournamentIds = [];
          this.tournamentIds = [];
          this.prevCategoryIds = [];
          this.categoryIds = [];
          this.prevOutrightsType = this.outrightsType;
        }

        let removedTournamentIds = [], newTournamentIds = [], removedCategoryIds = [], newCategoryIds = [];

        if (this.outrightsType === 'tournament') {
          this.tournamentIds = this.fixtureIds.filter(id => !id.startsWith('c'));
          removedTournamentIds = this.$parent.findDifference(this.prevTournamentIds, this.tournamentIds);
          newTournamentIds = this.$parent.findDifference(this.tournamentIds, this.prevTournamentIds);
        }

        if (this.outrightsType === 'category') {
          this.categoryIds = this.fixtureIds.filter(id => id.startsWith('c')).map(id => id.substring(1));
          removedCategoryIds = this.$parent.findDifference(this.prevCategoryIds, this.categoryIds);
          newCategoryIds = this.$parent.findDifference(this.categoryIds, this.prevCategoryIds);

          newTournamentIds = this.fixtureIds.filter(id => id.startsWith('x-')).map(t => t.replace('x-', ''));
        }

        if (!removedTournamentIds.length && !newTournamentIds.length &&
          !removedCategoryIds.length && !newCategoryIds.length) {
          return;
        }

        let outrightSports = JSON.parse(JSON.stringify(this.outrightSports));

        // tournament outrights
        if (removedTournamentIds.length) { // remove
          for (let i = 0; i < outrightSports.length; i++) {
            for (let j = 0; j < outrightSports[i].tabs.length; j++) {
              if (removedTournamentIds.includes(String(outrightSports[i].tabs[j].id))) {
                outrightSports[i].tabs.splice(j, 1);
              }
            }
            if (!outrightSports[i].tabs.length) {
              outrightSports.splice(i, 1);
            }
          }
          this.outrightSports = outrightSports;
        }

        if (newTournamentIds.length) { // add
          let tournamentOutrightsRequest = new TournamentOutrightsRequestService();
          // tournamentOutrightsRequest.getParams.tournamentData = newTournamentIds;
          tournamentOutrightsRequest.getParams.tournamentData = this.$route.name === 'seoTournamentGroup' ? [] : newTournamentIds.filter(i => !i.startsWith('tg'));
          tournamentOutrightsRequest.getParams.tournamentGroupData = this.$route.name === 'seoTournamentGroup' ? newTournamentIds : newTournamentIds.filter(i => i.startsWith('tg')).map(i => i.replace('tg', ''));
          tournamentOutrightsRequest.getParams.TimeFilter = DateFilterService.parseDateFilter(this.$route.params.fixtureDateFilter) || 0;

          tournamentOutrightsRequest.execute((response) => {
            response.data.forEach(s => {
              let responseSport = new FullSportModel(s);

              let matchingSport = outrightSports.find(s => s.id === responseSport.id);
              if (matchingSport) {
                responseSport.tabs.forEach(t => matchingSport.tabs.unshift(t));
              } else {
                outrightSports.unshift(responseSport);
              }
              this.activeSportTournaments = outrightSports.map(s => {
                const firstTournament = s.tabs.find(t => t.outrights.length > 0);
                return firstTournament ? firstTournament.id : 0;
              });
              this.outrightSports = outrightSports;
              this.shiftLastSport();
            });
          }, (error) => {
            console.error(error); // eslint-disable-line
          }).finally(() => {
            this.loading = false;
          });
        }

        this.prevTournamentIds = this.tournamentIds;

        if (removedCategoryIds.length) { 
          for (let i = 0; i < outrightSports.length; i++) {
            outrightSports[i].tabs = outrightSports[i].tabs.filter(tab => 
             { 
              !removedCategoryIds.includes(String(tab.categoryId));
              this.catTab = { idx: 0 }
             }
            );
            if (!outrightSports[i].tabs.length) {
              outrightSports.splice(i, 1);
            }
          }
        }

        if (newCategoryIds.length) {
          let categoryOutrightsRequest = new CategoryOutrightsRequestService();
          categoryOutrightsRequest.getParams.CategoryData = newCategoryIds;
          categoryOutrightsRequest.getParams.TimeFilter = DateFilterService.parseDateFilter(this.$route.params.fixtureDateFilter) || 0;

          categoryOutrightsRequest.execute((response) => {
            if (!response.data || !response.data.length) {
              return;
            }
            response.data.forEach(s => {
              let responseSport = new FullSportModel(s);

              let matchingSport = outrightSports.find(s => s.id === responseSport.id);
              if (matchingSport) {
                responseSport.tabs.forEach(t => matchingSport.tabs.unshift(t));
              } else {
                outrightSports.unshift(responseSport);
              }

              this.outrightSports = outrightSports;
              this.shiftLastSport();
            });
          }, (error) => {
            console.error(error); // eslint-disable-line
          });
        }

        this.prevCategoryIds = this.categoryIds;
      },
      shiftLastSport() {
        if (this.outrightsType === 'category') {
          let categoryTabIdx = this.outrightSports[0].tabs.findIndex(t => t.id === 0);
          if (categoryTabIdx !== -1) {
            let categoryTab = JSON.parse(JSON.stringify(this.outrightSports[0].tabs[categoryTabIdx]));
            this.outrightSports[0].tabs = this.outrightSports[0].tabs.filter((t, idx) => idx !== categoryTabIdx); //.splice(categoryTabIdx);
            this.outrightSports[0].tabs.unshift(categoryTab);
          }
          return;
        }

        let lastIdInRoute = this.fixtureIds[this.fixtureIds.length - 1];
        let lastSportIdx;

        if (lastIdInRoute.startsWith('c')) {
          lastSportIdx = this.outrightSports.findIndex(s => s.tabs.find(t => t.categoryId == lastIdInRoute.substring(1)));
        } else {
          lastSportIdx = this.outrightSports.findIndex(s => s.tabs.find(t => t.id == lastIdInRoute));
        }

        if (lastSportIdx !== 0 && typeof this.outrightSports[lastSportIdx] !== 'undefined') {
          let lastSport = JSON.parse(JSON.stringify(this.outrightSports[lastSportIdx]));
          this.outrightSports.splice(lastSportIdx);
          this.outrightSports.unshift(lastSport);
        }
      },
      getSportClass(sportId) {
        return store.getters.getSportClass(sportId);
      },
    },
  };
</script>
